import { Header } from "../../components/header"

export default function Recursos () {
    return <Header color={"#F0F0F0"}  />

}